import React from "react";
import SelectDropdown from "./shared/SelectDropdown";

const DropdownSelectMapping = (props) => {
  const options = props.mappings.map((mapping) => ({
    key: mapping.id ?? mapping.name,
    value: mapping,
    label: mapping.name,
  }));

  const value = props.mappings.find((mapping) => mapping.name === props.selectedMapping);

  return (
    <SelectDropdown
      fullWidth
      options={options}
      value={value}
      onChange={props.setSelectedMapping}
      placeholder={props.selectedMapping ?? "Select a mapping"}
    />
  );
};

export default DropdownSelectMapping;
